// src/utils/device.js
// Provides a stable per-browser/device identifier for web session binding.

const STORAGE_KEY = "ecat.web.deviceId";

function randomHex(len = 16) {
  const arr = new Uint8Array(len);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(arr);
  } else {
    for (let i = 0; i < len; i++) arr[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(arr)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function getLocalDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (id && typeof id === "string" && id.length > 0) return id;
    id = randomHex(16);
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch (e) {
    // Fallback to an in-memory id if localStorage is unavailable
    if (!window.__ECAT_TMP_DEVICE_ID__) {
      window.__ECAT_TMP_DEVICE_ID__ = randomHex(16);
    }
    return window.__ECAT_TMP_DEVICE_ID__;
  }
}

export function msUntil(tsMs) {
  const now = Date.now();
  const t = Number(tsMs || 0);
  return Math.max(0, t - now);
}

